<template>
    <section class="app-main">
        
        <el-card class="m-bottom-4">
            <el-row class="m-bottom-4">
               <el-col :span="2" class="input-label">兑换码设置：</el-col>
               <el-col :span="22">
                  <el-input placeholder="请输入兑换码" v-model="exchange_code"  style="width:532px;"></el-input>
               </el-col>
           </el-row>
           <el-row class="m-bottom-4">
               <el-col :span="2" class="input-label">兑换码类型：</el-col>
               <el-col :span="22">
                  <el-radio v-model="discount" :label="1" border>商品代金</el-radio>
                  <el-radio v-model="discount" :label="3" border>商品折扣</el-radio>
               </el-col>
           </el-row>
           <el-row class="m-bottom-4">
               <el-col :span="2" class="input-label">兑换码金额：</el-col>
               <el-col :span="22" v-if="discount == '1'">
                  <el-input placeholder="请输入兑换码金额(C$)" v-model="coupon_money"  style="width:532px;"></el-input>
               </el-col>
               <el-col :span="22" v-if="discount == '3'">
                  <el-input placeholder="请输入商品折扣率(%)" v-model="coupon_money"  style="width:532px;"></el-input>
               </el-col>
           </el-row>
           <el-row class="m-bottom-4">
               <el-col :span="2" class="input-label">发放数量：</el-col>
               <el-col :span="22">
                   <el-input placeholder="兑换码数量" v-model="stock"  style="width:532px;"></el-input>
               </el-col>
           </el-row>
        </el-card>

        <el-card class="m-bottom-4">
            
            <el-row class="m-bottom-4">
               <el-col :span="2" class="input-label">使用范围：</el-col>
               <el-col :span="22">
                  <el-radio v-model="range" :label="2" border>自营商品可用</el-radio>
               </el-col>
           </el-row>
           <el-row class="m-bottom-4">
               <el-col :span="2" class="input-label">领取规则：</el-col>
               <el-col :span="22">
                  <el-radio v-model="access" :label="2" border>登录领取</el-radio>
               </el-col>
           </el-row>
           <el-row class="m-bottom-4">
               <el-col :span="2" class="input-label">领取方式：</el-col>
               <el-col :span="22">
                  <el-radio v-model="get_coupon" :label="3" border>兑换码兑换</el-radio>
               </el-col>
           </el-row>
           
        </el-card>

        <el-card class="m-bottom-4">
            <el-row class="m-bottom-4">
               <el-col :span="2" class="input-label">有效日期：</el-col>
               <el-col :span="22">
                  <el-radio v-model="fixed" :label="1" border>固定日期</el-radio>
               </el-col>
           </el-row>
           <el-row class="m-bottom-4" v-if="fixed == 1">
               <el-col :span="2" class="input-label">选择日期：</el-col>
               <el-col :span="22">
                   <el-date-picker v-model="fixDate" type="daterange" value-format="timestamp" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
              </el-col>
           </el-row>
        </el-card>




        <el-card>
            <el-row class="m-bottom-4">
               <el-col :span="2" class="input-label">确认提交：</el-col>
               <el-col :span="22">
                   <el-button type="primary" :disabled="disabled"  @click="handleBtn()" style="width:160px;letter-spacing:1.5px;">Done</el-button>
               </el-col>
           </el-row>
        </el-card>

    </section>
</template>



<script>
import { coupon_add } from '@/api/market.js'
export default {
    data() {
        return {
            id: '',
            exchange_code: '',
            coupon_money: "",
            rule: "",
            rule_en: "",
            access: 2,
            range: 2,
            stock: '',
            discount: 1,
            get_number: 2,
            flag: 1,
            fixed: 1,
            fixed_time: '',
            user_get_num: 0,
            get_coupon: 3,

            fixDate: [],   //固定日期
            day_type: 1,

            disabled: false,
            
        }
    },
    methods: {




        // 显示 添加 || 修改 弹窗
        handleShow(row){
            if(row){
                this.dialog      = true
                this.id        = row.id
                this.name      = row.title
                this.path      = row.path
                this.identify  = row.identify
                this.sort      = row.sort_id
                this.status    = row.status
                this.is_module = row.is_module
                this.pid       = row.pid
            }else{
                this.dialog      = true
                this.id        = ''
                this.name      = ''
                this.path      = ''
                this.identify  = ''
                this.sort      = 0
                this.status    = 0
                this.is_module = 0
                this.pid       = ''
            }
        },
        // 弹窗里面 点击确定
        handleBtn(){
            this.dialog = false
            // 通过 this.id 为空来判断 添加 || 修改
            if(this.id == ""){
                this.handleAdd()
            }else{
                this.handlePut()
            }
            
        },
        handleAdd(){
            let params = {
                exchange_code : this.exchange_code,
                discount      : this.discount,
                stock         : this.stock,
                range         : this.range,
                access        : this.access,
                get_coupon    : this.get_coupon,
                user_get_num  : this.user_get_num,
                fixed         : this.fixed,
                rule          : '',
                rule_en       : '',
                coupon_logo   : 0,
                coupon_logo_en: 0,
            }

            if(this.exchange_code == '') {
                this.$message.error('请完善兑换码设置')
                return false
            }

            if( [1,3].includes(this.discount)  ) {
                if(this.coupon_money == '') {
                    this.$message.error('请先完善优惠券金额')
                    return false
                }else {
                     params.coupon_money = this.coupon_money
                }
                
            }

            if( this.stock == '') {
                this.$message.error('请完善 发放数量')
                return false
            }

            if(this.fixed == 1  ) {
                if(this.fixDate.length != 2) {
                    this.$message.error('请先完善开始日期、结束日期')
                    return false
                }else {
                    params.st_time  = this.fixDate[0]/1000
                    params.end_time = this.fixDate[1]/1000
                }
            }



            

            this.disabled = true

            coupon_add(params).then(res => {
                if(res){
                    this.$message({message:res.msg,type:'success'});
                }
            }).finally( ()=> {
                this.disabled = false
            })
        }
    },
    created(){
        
    }
}
</script>

<style lang="less" scoped>
    section {
        width: 100%;
        /deep/ .el-radio.is-bordered {
            width: 150px;
        }
        .input-label {
            height: 40px;
            line-height: 40px;
            min-width: 98px;
        }
    }
</style>
